import * as $ from 'jquery';

export function init() {
    if (!window.OneSignal) {
        return void 0;
    }

    const orderTrackingPrompt = $('[data-order-push-notifications-prompt]');

    if (orderTrackingPrompt.length) {
        OneSignal.push(function() {
            const orderTrackingPromptParameters = orderTrackingPrompt.data('order-push-notifications-prompt');
            OneSignal.on('subscriptionChange', function(isSubscribed) {
                if (isSubscribed) {
                     OneSignal.getUserId(function(userId) {
                        $.post({
                            url: orderTrackingPromptParameters.url,
                            data: JSON.stringify({
                                csrf_token: orderTrackingPromptParameters.csrf_token,
                                order_token: orderTrackingPromptParameters.order_token,
                                device_id: userId
                            })
                        }).done(function(response) {
                            console.log("Subscription resulted in:", response);
                        })
                    });
                }
            });
            OneSignal.getNotificationPermission(function(permission) {
                if (permission !== 'granted') {
                    OneSignal.showSlidedownPrompt();
                }
            });
        });
    }
}
